import { Timestamp, addDoc, collection } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { FaqGroupDataToCreate } from "../types";

export const createFaqGroup = async (
  faqGroupData: FaqGroupDataToCreate,
): Promise<void> => {
  const collectionRef = collection(db, `faqGroups`);
  await addDoc(collectionRef, {
    ...faqGroupData,
    createdAt: Timestamp.now(),
    updatedAt: Timestamp.now(),
  });
};
